/**
 * Novo registro de participação em eleição. Eleição, ano e sócio são
 * obrigatórios no banco — marcados como obrigatórios no formulário
 * para o erro aparecer antes do salvar (antes o servidor devolvia 500).
 */
import {
  AutocompleteInput,
  BooleanInput,
  CreateContextProvider,
  NumberInput,
  ReferenceInput,
  required,
  SimpleForm,
  TextInput,
  useCreateController,
} from "react-admin";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Grid";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";

export const UserElectionCreate = (props: any) => {
  const controller: any = useCreateController({
    resource: "user-elections/crud",
  });
  return (
    <CreateContextProvider value={controller}>
      <SimpleForm>
        <PageTopBreadcrumb
          title="Eleições"
          firstPath="/#/user-elections/crud"
          secondTitle="Novo"
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Nova Participação em Eleição" />
          <CardContent>
            <Grid container columnSpacing={2} rowSpacing={0.5}>
              <Grid item xs={12} md={8}>
                <TextInput
                  source="name"
                  label="Eleição"
                  fullWidth
                  helperText={false}
                  validate={required()}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <NumberInput
                  source="year"
                  label="Ano"
                  fullWidth
                  helperText={false}
                  validate={required()}
                />
              </Grid>
              <Grid item xs={12}>
                {/* Consulta só a partir de 2 caracteres (padrão das
                    demais buscas de sócio do painel) */}
                <ReferenceInput
                  source="userId"
                  reference="users/crud"
                  enableGetChoices={({ mailName }) =>
                    Boolean(mailName && String(mailName).trim().length >= 2)
                  }
                >
                  <AutocompleteInput
                    label="Sócio (nome/e-mail/CPF)"
                    optionText={(choice: any) =>
                      String(
                        choice?.fullName || choice?.email || choice?.id || ""
                      )
                    }
                    optionValue="id"
                    fullWidth
                    helperText={false}
                    noOptionsText="Digite nome, e-mail ou CPF para buscar"
                    filterToQuery={(searchText: string) => ({
                      mailName: searchText,
                    })}
                    validate={required()}
                  />
                </ReferenceInput>
              </Grid>
              <Grid item xs={12}>
                <BooleanInput
                  source="participated"
                  label="Participou da eleição"
                  helperText={false}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </CreateContextProvider>
  );
};
